<div class="content" [class.disabled]="isLoading && !isModalOpen">
  <h5 *ngIf="step == 'visual'">Añade Recursos</h5>
  
  <button *ngIf="step == 'visual' && canEdit" type="button" 
  [disabled]="!canEdit"
  (click)="openTreeModal()" nz-button>+ Agregar</button>
  <nz-radio-group 
  class="tow-column" 
  *ngIf="step == 'visual'"
  [(ngModel)]="optionVisualSelected" nzButtonStyle="solid" 
  (ngModelChange)="onChangeTypeOfVisual($event)">
    <label nz-radio-button nzValue="material">
      <span nz-icon nzType="diazar:materialIcon" style="font-size: 18px;"></span>
      Ver materiales
    </label>
    <label nz-radio-button nzValue="tree">
      <span nz-icon nzType="diazar:clusterIcon" style="font-size: 18px;"></span>
      Ver estructura
    </label>
  </nz-radio-group>

  <button (click)="onDeleteMassAction()" *ngIf="activeMassDeletion && canEdit" nz-button nzDanger>
    Eliminar
  </button>

  <div class="material-visual" *ngIf="initialResources.length > 0 && 
  step == 'visual' && optionVisualSelected == 'material'">
    <div *ngFor="let origin of initialResources" style="margin-bottom: 10px;">
       <div class="material-input border-all" *ngIf="isMaterialOrMachinery(origin)">
        <div class="title">
          <div class="material-name">
            @if(origin.type == "Material") {
            <span nz-icon nzType="diazar:materialIcon" style="font-size: 18px;">
            </span>
            }
            @if(origin.type == "Machinery") {
            <span nz-icon nzType="diazar:machineryIcon" style="font-size: 18px;">
            </span>
            }
            <span class="name">{{origin.name}}</span>
          </div>
        </div>
        <div class="content {{origin['notes'] ? '' :'no-border'}}">
         
          <span class="type">Cant. Requisitada:&nbsp;</span>
          <span class="value">{{origin.WBSResourceNode?.currentInputQuantity}}</span>
          
        </div>

        <div class="content-1 no-border" *ngIf="origin['notes']">
           <div class="field">
             <span class="type">Nota:&nbsp;</span>
              <span class="value">{{origin['notes']}}</span>
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <!-- Visual tree (structure view) -->
  <div class="material-selector" *ngIf="step == 'visual' && optionVisualSelected == 'tree'">
    <nz-tree class="visual margin-bottom-40" 
    *ngIf="displayedTree.length > 0"
    [nzExpandAll]="true"
    [nzData]="displayedTree" [nzCheckable]="true"
      [nzShowLine]="true" [nzShowIcon]="false" (nzCheckBoxChange)="onCheckBoxAction($event)"
      (nzClick)="onClickNode($event)" [nzTreeTemplate]="nzTreeTemplate">
    </nz-tree>
  </div>

  <!-- Floating button for visual edit mode -->
  <div class="floating-button" *ngIf="step == 'visual' && touchedResources.size > 0 && canEdit">
    <button (click)="onHandlerResourcesAction('edit')" 
      nz-button 
      nzType="primary"
      [disabled]="touchedResources.size == 0 || disabledAction || !canEdit" nzSize="large">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Actualizar materiales ({{touchedResources.size}})
    </button>
  </div>

  <!-- Tree template shared between visual and modal -->
  <ng-template #nzTreeTemplate let-node let-origin="origin">
    <div class="tree-input" *ngIf="!isMaterialOrMachinery(origin)">
      <span *ngIf="node.children.length > 0 && !node.isExpanded" nzType="caret-right" nzTheme="outline"
        style="font-size: 18px;">
      </span>
      <span *ngIf="node.children.length > 0 && node.isExpanded" nzType="caret-down" nzTheme="outline"
        style="font-size: 18px;">
      </span>

      @if(origin.type == 'Package') {
      <span nz-icon nzType="diazar:packageIcon" style="font-size: 18px;">
      </span>
      }
      @if(origin.type == 'Activity') {
      <span nz-icon nzType="diazar:activityIcon" style="font-size: 18px;">
      </span>
      }
      @if(origin.type == "ProductionUnitUnit") {
      <span nz-icon nzType="diazar:lotIcon" style="font-size: 18px;">
      </span>
      }
      @if(origin.type == "Material") {
      <span nz-icon nzType="diazar:materialIcon" style="font-size: 18px;">
      </span>
      }
      @if(origin.type == "Machinery") {
      <span nz-icon nzType="diazar:machineryIcon" style="font-size: 18px;">
      </span>
      }
      <span>&nbsp;{{origin.name}}</span>
    </div>

    <div class="material-input" *ngIf="isMaterialOrMachinery(origin)">
      <div class="title">
        <div class="material-name">
          @if(origin.type == "Material") {
          <span nz-icon nzType="diazar:materialIcon" style="font-size: 18px;">
          </span>
          }
          @if(origin.type == "Machinery") {
          <span nz-icon nzType="diazar:machineryIcon" style="font-size: 18px;">
          </span>
          }
          <span class="name {{step}}">{{origin.name}}</span>
          <a
          *ngIf="step == 'visual' && canEdit"
          nz-dropdown
          [nzTrigger]="'click'"
          [nzDropdownMenu]="menu1"
          nzPlacement="bottomRight"
          >
          <span nz-icon nzType="more"></span>
        </a>
        <nz-dropdown-menu #menu1="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="onDeleteItem(origin)">
              <span nz-icon nzType="delete"></span>
              Eliminar
            </li>
          </ul>
        </nz-dropdown-menu>
        </div>
      </div>
      <div class="content">
        
        <span class="type">Cant. Presup:&nbsp;</span>
        <span class="value">{{origin.WBSResourceNode.budgetedQuantity.toFixed(4)}}</span>

        <span class="type">Acum. Anterior:&nbsp;</span>
        <span class="value">{{origin.WBSResourceNode.previouslyConsumedQuantity.toFixed(4)}}</span>

        <span class="type">% Asig:&nbsp;</span>
        <span class="value">{{(origin.WBSResourceNode.currentInputPercentage * 100).toFixed(4)}}%</span>

        <span class="type">Cant. Requisitada:&nbsp;</span>
        <input nz-input placeholder="Cant. Requisitada" nzVariant="outlined"
          class="{{getClassInput(origin)}} value"
          [disabled]="!canEdit"
          [value]="origin.WBSResourceNode.currentInputQuantity.toFixed(4)" [type]="'number'" [min]="0"
          [max]="origin.WBSResourceNode.remainingQuantity" (input)="onMaterialChangeValue($event, origin)" />

        <span class="type">Acum Actual:&nbsp;</span>
        <span class="value">{{origin.WBSResourceNode.currentConsumedQuantity.toFixed(4)}}</span>

        <span class="type">Saldo Actual:&nbsp;</span>
        <span class="value">{{origin.WBSResourceNode.currentRemainingQuantity.toFixed(4)}}</span>


        <div class="error-content" *ngIf="origin.hasError">
          <span class="error">{{origin.hasError}}</span>
        </div>
        <span class="type">Acum Total:&nbsp;</span>
        <span class="value">
          {{origin.WBSResourceNode.totalConsumedQuantity.toFixed(4) }}
        </span>
         <span class="type">Saldo Total:&nbsp;</span>
        <span class="value">
          {{origin.WBSResourceNode.totalRemainingQuantity.toFixed(4) }}
        </span>
      </div>

      <div class="input-field no-border">
        <span class="type">Nota:&nbsp;</span>
        <input style="max-width: 200px;" [disabled]="!canEdit" nz-input placeholder="Nota" nzVariant="outlined" [value]="origin.notes ?? ''" [type]="'text'"
          (input)="onAddNoteToMaterial($event, origin)" />
      </div>
    </div>
  </ng-template>

</div>

<!-- Full-screen modal for tree selection -->
<nz-modal
  [(nzVisible)]="isModalOpen"
  nzTitle="Búsqueda Avanzada"
  [nzWidth]="'100vw'"
  [nzStyle]="{ top: '0', 'padding-bottom': '0' }"
  [nzBodyStyle]="{ height: 'calc(100vh - 110px)', overflow: 'auto' }"
  nzClassName="fullscreen-tree-modal"
  [nzFooter]="modalFooter"
  (nzOnCancel)="closeTreeModal()"
  [nzClosable]="true"
  [nzMaskClosable]="false"
>
  <ng-container *nzModalContent>
    <div class="modal-tree-content" [class.disabled]="isLoading">
      <div class="header" *ngIf="modalStep == 'resources'">
        <button nz-button (click)="onModalBack()">
          <span nz-icon nzType="left"></span>
        </button>
        <h4>
          {{displayedTree.length > 0 ? displayedTree[0].title : ""}}
        </h4>
      </div>

      <!-- Search box -->
      <div class="searchbox">
        <input [(ngModel)]="searchTerm" nz-input placeholder="Buscar por nombre" 
        nzVariant="outlined" 
        (input)="handlerSearch()" />
      </div>

      <!-- Distribution -->
      <div class="searchbox" *ngIf="modalStep == 'resources' && canEdit">
        <span>Distribuir</span>
        <input [(ngModel)]="quantityDistribution" nz-input placeholder="Distribuir cantidad" 
        type="number"
        nzVariant="outlined" 
        />
        <button nz-button 
        (click)="onDistribution()"
        nzType="primary"
        [disabled]="distributingElements.length == 0 || !this.quantityDistribution || !this.canEdit">
          <span nz-icon nzType="check"></span>
        </button>
      </div>

      <nz-tree class="{{modalStep}} margin-bottom-40" 
      *ngIf="displayedTree.length > 0"
      [nzExpandAll]="true"
      [nzData]="displayedTree" [nzCheckable]="modalStep == 'resources'"
        [nzShowLine]="true" [nzShowIcon]="false" (nzCheckBoxChange)="onCheckBoxAction($event)"
        (nzClick)="onModalClickNode($event)" [nzTreeTemplate]="modalTreeTemplate">
      </nz-tree>

      <ng-template #modalTreeTemplate let-node let-origin="origin">
        <div class="tree-input" *ngIf="!isMaterialOrMachinery(origin)">
          <span *ngIf="node.children.length > 0 && !node.isExpanded" nzType="caret-right" nzTheme="outline"
            style="font-size: 18px;">
          </span>
          <span *ngIf="node.children.length > 0 && node.isExpanded" nzType="caret-down" nzTheme="outline"
            style="font-size: 18px;">
          </span>

          @if(origin.type == 'Package') {
          <span nz-icon nzType="diazar:packageIcon" style="font-size: 18px;"></span>
          }
          @if(origin.type == 'Activity') {
          <span nz-icon nzType="diazar:activityIcon" style="font-size: 18px;"></span>
          }
          @if(origin.type == "ProductionUnitUnit") {
          <span nz-icon nzType="diazar:lotIcon" style="font-size: 18px;"></span>
          }
          @if(origin.type == "Material") {
          <span nz-icon nzType="diazar:materialIcon" style="font-size: 18px;"></span>
          }
          @if(origin.type == "Machinery") {
          <span nz-icon nzType="diazar:machineryIcon" style="font-size: 18px;"></span>
          }
          <span>&nbsp;{{origin.name}}</span>
        </div>

        <div class="material-input" *ngIf="isMaterialOrMachinery(origin)">
          <div class="title">
            <div class="material-name">
              @if(origin.type == "Material") {
              <span nz-icon nzType="diazar:materialIcon" style="font-size: 18px;"></span>
              }
              @if(origin.type == "Machinery") {
              <span nz-icon nzType="diazar:machineryIcon" style="font-size: 18px;"></span>
              }
              <span class="name resources">{{origin.name}}</span>
            </div>
          </div>
          <div class="content">
            <span class="type">Cant. Presup:&nbsp;</span>
            <span class="value">{{origin.WBSResourceNode.budgetedQuantity.toFixed(4)}}</span>

            <span class="type">Acum. Anterior:&nbsp;</span>
            <span class="value">{{origin.WBSResourceNode.previouslyConsumedQuantity.toFixed(4)}}</span>

            <span class="type">% Asig:&nbsp;</span>
            <span class="value">{{(origin.WBSResourceNode.currentInputPercentage * 100).toFixed(4)}}%</span>

            <span class="type">Cant. Requisitada:&nbsp;</span>
            <input nz-input placeholder="Cant. Requisitada" nzVariant="outlined"
              class="{{getClassInput(origin)}} value"
              [disabled]="!canEdit"
              [value]="origin.WBSResourceNode.currentInputQuantity.toFixed(4)" [type]="'number'" [min]="0"
              [max]="origin.WBSResourceNode.remainingQuantity" (input)="onMaterialChangeValue($event, origin)" />

            <span class="type">Acum Actual:&nbsp;</span>
            <span class="value">{{origin.WBSResourceNode.currentConsumedQuantity.toFixed(4)}}</span>

            <span class="type">Saldo Actual:&nbsp;</span>
            <span class="value">{{origin.WBSResourceNode.currentRemainingQuantity.toFixed(4)}}</span>

            <div class="error-content" *ngIf="origin.hasError">
              <span class="error">{{origin.hasError}}</span>
            </div>
            <span class="type">Acum Total:&nbsp;</span>
            <span class="value">{{origin.WBSResourceNode.totalConsumedQuantity.toFixed(4)}}</span>
            <span class="type">Saldo Total:&nbsp;</span>
            <span class="value">{{origin.WBSResourceNode.totalRemainingQuantity.toFixed(4)}}</span>
          </div>

          <div class="input-field no-border">
            <span class="type">Nota:&nbsp;</span>
            <input style="max-width: 200px;" [disabled]="!canEdit" nz-input placeholder="Nota" nzVariant="outlined" [value]="origin.notes ?? ''" [type]="'text'"
              (input)="onAddNoteToMaterial($event, origin)" />
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="primary" 
      *ngIf="modalStep == 'resources'"
      [disabled]="touchedResources.size == 0 || disabledAction || !canEdit"
      (click)="onAddFromModal()">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Agregar a requisición ({{touchedResources.size}})
    </button>
  </ng-template>
</nz-modal>

<div class="loading-overlay" *ngIf="isLoading">
  <nz-spin [nzSpinning]="true" [nzSize]="'large'"></nz-spin>
</div>
